import styled from 'styled-components';

const ImageHead = styled.div`
  img{
    width: 100%;
  }
`;

export default ImageHead;
